import { useState } from 'react';
import TableSolid from '@simplywallst/ui-core/icons/TableSolid';
import { Button } from '@simplywallst/ui-core';
import styled from 'styled-components';
import loadable from '@loadable/component';

const DCFRawDataModal = loadable(() => import('./DCFRawDataModal'));

const ViewData = styled(Button)`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
`;

type Props = { companyId: string };

const DCFRawData = ({ companyId }: Props) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      {showModal && (
        <DCFRawDataModal
          companyId={companyId}
          onClose={() => setShowModal(false)}
        />
      )}
      <ViewData
        data-cy-id={`chart-action-raw-data-${companyId}`}
        styleType="gentle"
        alignIcon="left"
        marginRight
        onClick={() => setShowModal(true)}
      >
        <TableSolid /> View Data
      </ViewData>
    </>
  );
};

export default DCFRawData;
